import { GEO, MAPS_URL, REVIEWS_URL } from "@/lib/siteContent";

export const SITE = "https://chatymara.com";
// Summer exterior 1200x630 crop, generated alongside /gallery/hero.webp.
// Also used by scripts/prerender.js; keep in sync.
export const HERO_OG = `${SITE}/gallery/og.jpg`;

export const buildLodgingSchema = (t, lang) => ({
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  "@id": `${SITE}/#business`,
  name: t.brand.name,
  alternateName: ["Chatymara", "chatymara.com"],
  description: t.seo.description,
  url: lang === "en" ? `${SITE}/en` : `${SITE}/`,
  inLanguage: lang === "en" ? "en" : "sk",
  image: [
    HERO_OG,
    "https://chatymara.com/media/67ff637b71384b7af3b9d3bd.webp",
    "https://chatymara.com/media/67ff637b71384b1e04b9d3ba.webp",
    "https://chatymara.com/media/67ff637b71384b7b67b9d3bc.webp",
  ],
  telephone: t.brand.phone,
  email: t.brand.email,
  priceRange: "€180 to €300",
  currenciesAccepted: "EUR",
  hasMap: MAPS_URL,
  sameAs: [MAPS_URL, REVIEWS_URL],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Ižipovce 70",
    addressLocality: "Ižipovce",
    postalCode: "032 23",
    addressRegion: lang === "en" ? "Žilina Region" : "Žilinský kraj",
    addressCountry: "SK",
  },
  geo: { "@type": "GeoCoordinates", latitude: GEO.lat, longitude: GEO.lng },
  areaServed:
    lang === "en" ? ["Liptov", "Liptovský Mikuláš", "Slovakia"] : ["Liptov", "Liptovský Mikuláš", "Slovensko"],
  amenityFeature: t.amenities.map((a) => ({
    "@type": "LocationFeatureSpecification",
    name: a.label,
    value: true,
  })),
  checkinTime: "15:00",
  checkoutTime: "10:00",
  petsAllowed: false,
});

export const buildWebSiteSchema = (t, lang) => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE}/#website`,
  // Umbrella site brand. The property/business entity stays Chata Ižipovce.
  name: t.site?.name ?? "Chaty Mara",
  alternateName: ["Chatymara", "chatymara.com", "Chata Mara", "Chata Ižipovce"],
  url: `${SITE}/`,
  inLanguage: lang === "en" ? "en" : "sk",
  publisher: { "@id": `${SITE}/#business` },
});

// Mirrors the local guide rendered in the Attractions section and landing page.
export const buildNearbySchema = (t, lang) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: lang === "en" ? "Attractions near Chata Ižipovce" : "Atrakcie v okolí Chaty Ižipovce",
  itemListElement: (t.localGuide?.places ?? []).map((p, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: {
      "@type": "TouristAttraction",
      name: p.name,
      description: p.body,
      ...(p.href ? { url: p.href } : {}),
    },
  })),
});

/** items: [{q, a}]. Works for the homepage FAQ and landing-page subsets alike. */
export const buildFaqSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

/** crumbs: [{name, item}] in order. */
export const buildBreadcrumbSchema = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.name,
    item: c.item,
  })),
});
